module.exports = __webpack_public_path__ + "img/walletconnect.e3b16188.svg";